<template>
  <div>
    <el-form :model="ruleForm2"
             :rules="rules2"
             ref="ruleForm2"
             label-position="left"
             label-width="0px"
             status-icon
             @keyup.enter.native="handleSubmit"
             class="demo-ruleForm login-container">
      <el-row :gutter="20">
        <el-col :span="10"
                :offset="1">
          <h3 class="title">账号登录</h3>
          <el-form-item prop="account">
            <el-input type="text"
                      v-model="ruleForm2.account"
                      auto-complete="off"
                      placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input type="password"
                      v-model="ruleForm2.checkPass"
                      auto-complete="off"
                      placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item style="width:100%;">
            <el-button type="primary"
                       style="width:100%;"
                       @click.native.prevent="handleSubmit">登录
            </el-button>
            <div style="color:red;">{{msg}}</div>
          </el-form-item>
        </el-col>
        <el-col :span="10"
                :offset="2">
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios'
import { localStorage } from '@/deps/utils'
export default {
  data () {
    return {
      msg: '',
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: ''
      },
      rules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.msg = ''
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.logining = true
          axios.post('dev/login', {
            account_name: this.ruleForm2.account,
            account_passwd: this.ruleForm2.checkPass
          })
            .then(response => {
              this.logining = false
              console.log(response)
              if (response.data.code === 200) {
                this.$router.push('/main')
                localStorage.setItem('account_name', this.ruleForm2.account)
              } else {
                this.msg = response.data.error
              }
            })
            .catch(error => {
              this.logining = false
              console.log(error)
            })
        }
      })
    }
  },
  mounted () {
  }
}

</script>
<style>
.el-loading-mask {
  position: absolute;
  z-index: 800;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  -webkit-transition: opacity 0.3s;
  transition: opacity 0.3s;
}
</style>
<style scoped>
.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: 180px auto;
  width: 850px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}

.title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue